export const DRAWER_WIDTH = 340;
